/** @format */
import React, { useEffect, useRef, useState } from "react";
import { Box, Toolbar, Typography, Divider } from '@mui/material';
import { useOutletContext } from "react-router-dom";
import * as pdfjs from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker?url";
import Loader from "../Loader";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

const SelectedTemplatePdfPreview = ({ pdfUrl, }) => {
  const { open } = useOutletContext();
  const [numPages, setNumPages] = useState(null);
  const [pdf, setPdf] = useState(null);
  const canvasRefs = useRef([]);  
  const thumbnailRefs = useRef([]);
  const [activePage, setActivePage] = useState(0);
  const viewerRef = useRef(null);
  const [loader, setLoader] = useState(false);
  
  useEffect(() => {
    const loadPdf = async () => {
      setLoader(true)
      const loadingTask = pdfjs.getDocument(pdfUrl);
      const pdfDoc = await loadingTask.promise;
      setNumPages(pdfDoc.numPages);
      setPdf(pdfDoc);
    };

    loadPdf();
  }, [pdfUrl]);

  useEffect(() => {
    if (!pdf) return;

    const renderPages = async () => {
        setLoader(true)
        for (let i = 1; i <= numPages; i++) {
            const page = await pdf.getPage(i);
            const viewport = page.getViewport({ scale: 1.5 });

            const canvas = canvasRefs.current[i - 1];
            if (!canvas) continue;

            const context = canvas.getContext("2d");
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            const renderContext = { canvasContext: context, viewport };
            page.render(renderContext);
            setLoader(false);
        }
    };

    renderPages();
  }, [pdf, numPages]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActivePage(Number(entry.target.dataset.index));
          }
        });
      },
      { root: viewerRef.current, rootMargin: "0px", threshold: 0.6 }
    );

    canvasRefs.current.forEach((canvas, index) => {
      if (canvas) {
        canvas.dataset.index = index;
        observer.observe(canvas);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [numPages]);


  return (<>
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        transition: "margin 0.3s ease",
        height: "calc(100% - 0px)",
        display: "flex",
      }}
    >
      <Box sx={{ display: "flex", width: "100%", height: "100%", borderRadius: "12px", background: "#F6F6F6", p: 2,}}>

        <Box
          sx={{
            flexGrow: 1,
            textAlign: "center",
            width: "75%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            overflowY: "auto",
            overflowX: "hidden",
            borderRadius: "20px"
          }}
        >
          {Array.from({ length: numPages }, (_, index) => (
            <canvas
              key={index}
              ref={(el) => (canvasRefs.current[index] = el)}
              style={{ marginBottom: "20px", border: "1px solid #ddd", scrollMarginTop: "10px", width: "65%", borderRadius: "20px", width: "437px" }}
            />
          ))}
        </Box>
      </Box>
    </Box>
    {loader && <Loader />}
    </>
  );
};

export default SelectedTemplatePdfPreview;
